<template>

    <slider :pages="slideList" :sliderinit="sliderinit">
        <!-- slot  -->
    </slider>

    <!--
    <div class="container">
        <div class="row">
            <div class="col-sm-4 col-xs-12">
                <h3>OUR SOLUTIONS</h3>
                <p>
                    At AMS Controls, we make the best machine controls in the world. We offer control solutions for hundreds of machine types. These solutions improve accuracy, quality, efficiency, and most importantly, they gather <strong>information</strong> about what’s really happening at each machine. This information, along with Eclipse Production Management Software, allows our customers to truly manage their production. 
                </p>
            </div>
            <div class="col-sm-4 col-xs-12">
                <h3>PATHFINDER MACHINE CONTROLS</h3>
                <p>
                    It’s the world’s easiest to use graphic controller for folding machines. Simply trace a profile with your finger and Pathfinder’s algorithms will program the optimal fold sequences in milliseconds and then automatically execute it, delivering fast, professional results every time.
                </p>
            </div>
            <div class="col-sm-4 col-xs-12">
                <h3>Upcoming News</h3>
            </div>
        </div>
    </div>
    -->
</template>

<script>
import slider from '../vue-slider/slider.vue'
import {getStrRes, getUrlStr} from '../../util/MultiLang.js'
export default {
    components: {
        'slider': slider
    },
    methods: {
        getStrRes,
        getUrlStr
    },
    data() {
        
        return {
            slideList:[
                {
                    title: '',
                    style:{
                        background:'url(/assets/img/slide/IMG_5670.jpg?v=20181010)'
                    },
                    url: this.getUrlStr('/products/cu-purlin-roll-forming-machine')
                },
                {
                    title: '',
                    style:{
                        background:'url(/assets/img/slide/IMG_5668.jpg?v=20181010)'
                    },
                    url: this.getUrlStr('/products/cu-purlin-roll-forming-machine')
                },
                {
                    title: '',
                    style:{
                        background:'url(/assets/img/slide/IMG_5833.jpg?v=20181010)'
                    },
                    url: this.getUrlStr('/formia-solutions/te23_1100')
                },
                {
                    title: '',
                    style:{
                        background:'url(/assets/img/slide/DSC_0024.jpg?v=20181010)'
                    },
                    url: this.getUrlStr('/oem')
                },
                {
                    title: '',
                    style:{
                        background:'url(/assets/img/slide/IMG_5734.jpg?v=20181010)'
                    },
                    url: this.getUrlStr('/amscontrols/ams-xl200-ctrls')
                }
            ],

            sliderinit: {
                currentPage: 0,
                start: {},
                end: {},
                tracking: false,
                thresholdTime: 2000,
                hresholdDistance: 500,
                autoplay:2000,
                loop:true
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// Home.vue?34e3f44e